module.exports = "/lucky-balls/video/bonus_green.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/bonus_green.mp4
// module id = 892
// module chunks = 0